export const billingNotification = data => {
  let notifications = false
  if (data) {
    let newData
    let total
    let flags = []
    newData = data
    newData.map(x => {
      total = [...x.expenses, ...x.additional_expenses]
      total.map(y => {
        flags.push(y.crew_flag_status)
        flags.push(y.client_flag_status)
        flags.map(z => {
          if (z === "flagged") {
            notifications = true
          }
        })
      })
    })
  }

  return notifications
}
